import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { isVerticalIpadMini } from '../../common/responsiveUtils';
import Theme from '../../styles/Theme';
import { styled } from '@mui/material';

const CustomSnackbar = () => {
  const { palette, typography } = Theme;
  const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent': {
      ...typography.body14bold,
      width: isVerticalIpadMini() ? '750px' : '992px',
      height: '56px',
    },
    '&.notistack-MuiContent-default': {
      backgroundColor: palette.primary.light,
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: palette.error.main,
    },
  }));

  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      Components={{
        default: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
      }}
      iconVariant={{
        default: <CheckIcon sx={{ marginRight: '8px' }} />,
        error: <InfoOutlinedIcon sx={{ marginRight: '8px' }} />,
      }}
    />
  );
};

export default CustomSnackbar;
